import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateAgoPipe } from '../pipes/date-ago.pipe';
import { DateAgePipe } from '../pipes/date-age.pipe';
import { MaxCharsDisplayPipe } from '../pipes/max-chars-display';
import { RevealCandidateButtonComponent } from '../components/reveal-candidate-button/reveal-candidate-button.component';

@NgModule({
  imports: [CommonModule, TranslateModule, MatButtonModule, MatIconModule, MatTooltipModule],
  declarations: [DateAgoPipe, DateAgePipe, MaxCharsDisplayPipe, RevealCandidateButtonComponent],
  exports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    DateAgoPipe,
    DateAgePipe,
    MaxCharsDisplayPipe,
    RevealCandidateButtonComponent,
  ],
  providers: [TranslateService],
})
export class SharedModule {}
